export default __webpack_public_path__ + "static/media/concern-icon.40e08171.svg";